import type { CSSProperties, HTMLAttributes } from 'react'
import type { GradientPreset } from './presets.ts'
import { gradientPresets } from './presets.ts'
import styles from './GradientText.module.css'

export interface GradientTextProps extends HTMLAttributes<HTMLSpanElement> {
  gradient?: GradientPreset
  from?: string
  to?: string
  via?: string
  angle?: number
}

export function GradientText({
  gradient,
  from,
  to,
  via,
  angle = 135,
  className,
  style,
  ...props
}: GradientTextProps) {
  const preset = gradient ? gradientPresets[gradient] : undefined
  const resolvedFrom = from ?? preset?.from ?? 'var(--nexus-purple)'
  const resolvedTo = to ?? preset?.to ?? 'var(--nexus-pink)'

  const stops = via ? `${resolvedFrom}, ${via}, ${resolvedTo}` : `${resolvedFrom}, ${resolvedTo}`

  return (
    <span
      className={[styles.gradient, className].filter(Boolean).join(' ')}
      style={{
        '--gradient-stops': stops,
        '--gradient-angle': `${angle}deg`,
        ...style,
      } as CSSProperties}
      {...props}
    />
  )
}
